import React from 'react'
import { Link } from 'gatsby'
import Layout from '../layouts/layout'
import SEO from '../components/seo'
import TitleHeader from '../components/titleheader'
import Card from '../components/card'

import headerimage from '../assets/images/whoweare/Corprate_WhoWeAre_01.jpg'
import mbheaderimage from '../assets/images/whoweare/CORPORATE_SITE__HEADER_MB_WHOWEARE.jpg'
import tileimage1 from '../assets/images/whoweare/Corprate_WhoWeAre_02.jpg'
import tileimage2 from '../assets/images/whoweare/Corprate_WhoWeAre_03.jpg'
import tileimage3 from '../assets/images/whoweare/Corprate_WhoWeAre_04.jpg'
import tileimage4 from '../assets/images/whoweare/Corprate_WhoWeAre_05.jpg'

import toggleGroupA from '../assets/images/canada.jpg'
import toggleGroupB from '../assets/images/usa.jpg'

import { trackPageData, getPageDetails } from '../analytics'

class WhoWeAre extends React.PureComponent {
  constructor(props) {
    super(props)

    let dataManager = { pageDetails: {} }
    if (typeof window !== `undefined` && window.dataManager) {
      dataManager = window.dataManager
    }
    dataManager.pageDetails = getPageDetails()

    this.state = {
      activeGroup: 'A',
      isCorpCanada: false,
    }
  }

  componentDidMount() {
    trackPageData()

    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      const isCanada = params.has('corp-canada')
      this.setState({ isCorpCanada: isCanada })

      // Add body class for CSS targeting nav/footer only when parameter is present
      if (isCanada) {
        document.body.classList.add('corp-canada-page')
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('corp-canada-page')
  }

  toggleGroup = () => {
    this.setState((prev) => ({
      activeGroup: prev.activeGroup === 'A' ? 'B' : 'A',
    }))
  }

  render() {
    const { activeGroup, isCorpCanada } = this.state

    return (
      <Layout>
        {/* =====================================================
            PAGE WRAPPER
            Use .who-we-are-page for page-specific styling unrelated to hide/show logic
        ====================================================== */}
        <div className="who-we-are-page">

          {/* Toggle button — only shows when ?corp-canada is present */}
          {isCorpCanada && (
            <div className="row mb-4" style={{ position: 'relative' }}>
              <div className="col-12 text-center" style={{ position: 'absolute', right: '10%' }}>
                <img
                  src={activeGroup === 'A' ? toggleGroupA : toggleGroupB}
                  alt="Toggle content view"
                  onClick={this.toggleGroup}
                  style={{ cursor: 'pointer', width: '30px', float: 'right' }}
                />
              </div>
            </div>
          )}

          {/* ================= GROUP A ================= */}
          {activeGroup === 'A' && (
            <>
              <SEO
                title="Who We Are | The Children's Place Corporate Website"
                description="Learn more about The Children's Place on The Children's Place Corporate Website."
              />

              <div className="row mb-3">
                <div className="col-12">
                  <TitleHeader
                    image={headerimage}
                    mbheaderimage={mbheaderimage}
                    title="WHO WE ARE"
                  />
                  <p className="text-center mb-3">
                    We have achieved our success on the basis of a very simple principle: Trust.
                    <br className="d-none d-md-inline-block" />
                    <br/>
                    Wherever and whenever our customers choose to shop with us, they trust
                    <br className="d-none d-md-inline-block" />
                    <br/>
                    The Children’s Place, Gymboree, Sugar &amp; Jade and PJ Place to provide quality,
                    value and style.
                  </p>

                  {isCorpCanada && (
             
             <p>The Children’s Place was founded in Hartford, Connecticut in 1969 by David Pulver and Clinton Clark. They began by selling toys, apparel and accessories before deciding that apparel had the most growth potential.
<br/>
<br/>
By the early 1980s, The Children’s Place was repositioned as a specialty retailer of children’s apparel for newborns to pre-teens and began offering private label merchandise as well as branded product.
<br/>
<br/>
In 2019, The Children’s Place purchased the rights to the Gymboree brand and in early 2020, launched product in select stores and online. This iconic brand features colorful designs in playful, bow-to-toe collections that celebrate childhood and help families look their best for any occasion. In late 2021, the Sugar & Jade brand was launched featuring collections tailored to celebrate tween girls’ individuality. In late 2022, the PJ Place brand was launched as a one-stop pajama destination for all ages, including adults. Together, our four brands support growing families across every demographic with apparel that builds confidence and promotes inclusivity.</p>
       
       )}
                </div>
              </div>

     

              {!isCorpCanada && (
                <>
                  <div className="row mb-5">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Link to="/about-us">
                        <Card image={tileimage1} title="ABOUT US" />
                      </Link>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Link to="/senior-leadership">
                        <Card
                          image={tileimage2}
                          title={['SENIOR ', <br key="br1" />, 'LEADERSHIP']}
                        />
                      </Link>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Link to="/board-of-directors">
                        <Card image={tileimage3} title="BOARD OF DIRECTORS" />
                      </Link>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 remove-from-page">
                      <Link to="/international-franchises">
                        <Card image={tileimage4} title="INTERNATIONAL FRANCHISES" />
                      </Link>
                    </div>
                  </div>
                </>
              )}

         
            </>
          )}

          {/* ================= GROUP B ================= */}
          {activeGroup === 'B' && (
            <>
              <SEO
                title="QUI NOUS SOMMES | The Children's Place Corporate Website"
                description="Learn more about The Children's Place on The Children's Place Corporate Website."
              />

              <div className="row mb-3">
                <div className="col-12">
                  <TitleHeader
                    image={headerimage}
                    mbheaderimage={mbheaderimage}
                    title="QUI NOUS SOMMES"
                  />
                  <p className="text-center mb-3">
                    Notre succès repose sur un principe très simple : la confiance.
                    <br className="d-none d-md-inline-block" />
                    <br/>
                    Quand et où que vous soyez, nos clients choisissent de faire leurs achats chez nous,
                    ils font confiance
                    <br className="d-none d-md-inline-block" />
                    <br/>
                    à The Children’s Place, Gymboree, Sugar &amp; Jade et PJ Place pour leur offrir
                    qualité, valeur et style.
                  </p>

                  {isCorpCanada && (
              
              
                <p>Fondée en 1969 à Hartford, au Connecticut, par David Pulver et Clinton Clark, The Children’s Place débuta en vendant jouets, vêtements et accessoires. Rapidement, les vêtements se révélèrent comme le secteur à plus fort potentiel de croissance.
<br/>
<br/>
Dès les années 1980, The Children’s Place s’est repositionnée comme un détaillant spécialisé en vêtements pour enfants, du nouveau-né au préadolescent, offrant aussi bien des produits de marque privée que des articles de marques reconnues.  
<br/>
<br/>
En 2019, The Children’s Place acquit les droits de la marque Gymboree et lança, début 2020, des produits dans certaines boutiques et en ligne. Cette marque emblématique se distingue par ses modèles colorés et ses collections complètes, célébrant l’enfance et permettant aux familles de rayonner en toute occasion. Fin 2021, la marque Sugar & Jade fut lancée, avec des collections conçues pour affirmer l’individualité des filles préadolescentes. Fin 2022, la marque PJ Place a vu le jour en tant que destination unique pour les pyjamas de tous âges, y compris les adultes. Ensemble, nos quatre marques accompagnent les familles en pleine croissance à travers tous les profils démographiques avec des vêtements qui renforcent la confiance et favorisent l’inclusivité.
</p>
            
            
          
    )}
                </div>
              </div>
       

              {!isCorpCanada && (
                <>
                  <div className="row mb-5">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Link to="/about-us">
                        <Card image={tileimage1} title="À PROPOS DE NOUS" />
                      </Link>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Link to="/senior-leadership">
                        <Card
                          image={tileimage2}
                          title={['SENIOR ', <br key="br1" />, 'DIRECTION']}
                        />
                      </Link>
                    </div>
                  </div>

                  <div className="row mb-5">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <Link to="/board-of-directors">
                        <Card image={tileimage3} title="CONSEIL D'ADMINISTRATION" />
                      </Link>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 remove-from-page">
                      <Link to="/international-franchises">
                        <Card image={tileimage4} title="FRANCHISES INTERNATIONALES" />
                      </Link>
                    </div>
                  </div>
                </>
              )}

              
          
            </>
          )}

        </div>
      </Layout>
    )
  }
}

export default WhoWeAre
